import api from "./axios";
import { viewDocumentInline } from "./referralApi";

export const getProviderCredentials = (providerId) =>
  api.get(`/api/v1/credentials/provider/${providerId}`).then((r) => r.data);

export const createCredential = (providerId, payload) =>
  api
    .post(`/api/v1/credentials?providerId=${providerId}`, payload)
    .then((r) => r.data);

export const updateCredential = (credentialId, providerId, payload) =>
  api
    .put(
      `/api/v1/credentials/${credentialId}?providerId=${providerId}`,
      payload,
    )
    .then((r) => r.data);

export const deleteCredential = (credentialId, providerId) =>
  api.delete(`/api/v1/credentials/${credentialId}?providerId=${providerId}`);

export const uploadCredentialDocument = (
  credentialId,
  providerId,
  file,
  category,
) => {
  const form = new FormData();
  form.append("file", file);
  form.append("providerId", String(providerId));
  form.append("category", category);
  return api
    .post(`/api/v1/credentials/${credentialId}/documents`, form)
    .then((r) => r.data);
};

export const deleteCredentialDocument = (documentId, providerId) =>
  api.delete(
    `/api/v1/documents/${documentId}/provider?providerId=${providerId}`,
  );

export { viewDocumentInline as viewCredentialDocument };
